/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import Chips from "../../CommonButtons/Chips";
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import SecondaryRightIconSmallButton from "../../CommonButtons/SecondaryRightIconSmallButton";
import SwitcherTabs from "../../CommonButtons/SwitcherTabs";
import SearchBarWithCTA from "../../CommonSearchComponents/SearchBarWithCTA";
import CommonToast from "../../CommonToast";
import CommonCountMultiSelect from "../../NumberCountComponent/CommonCountMultiSelect";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 */
/**
 * @typedef {("white" | "black")} HoverOption
 */
/**
 * @param {Object} props
 * @param {string} props.headerTitle - Main title text to display at the top of popup
 * @param {string} [props.headersubtext] - Subtitle/description text below headers
 * @param {OnClickEventHandler} [props.closehandleFunction] - Handle function when close button is clicked
 * @param {boolean} [props.closeisDisabled] - Disable close button (true/false)
 * @param {React.RefObject} [props.closebuttonRef] - Button ref for close button (optional)
 * @param {string} [props.closeimgColor] - Icon color for close button (CSS variable)
 * @param {string} [props.ctatxtColor] - Text color for CTA button
 * @param {string} [props.nolablefound] - Message when no labels found
 * @param {Array} props.labels - Array of available labels
 * @param {Function} props.setLabels - Function to update labels array
 * @param {string|Array} props.LabelAccounts - Account ID(s) to assign labels to
 * @param {boolean} props.isLabelPopupOpen - Whether popup is open
 * @param {Array} [props.filteredData] - Filtered account data
 * @param {string} [props.type] - Type of label operation: "create", "beneTxn", "internalTxn", "owner", "internal"
 * @param {Function} [props.setSelectedLabelsCreate] - Function to set selected labels for create type
 * @param {Array} [props.selectedLabelsCreate] - Selected labels for create type
 * @param {Array} [props.txnPayLoad] - Transaction payload for labels
 * @param {OnClickEventHandler} [props.onClose] - Handle function when popup is closed
 * @returns {JSX.Element}
 */
const CommonAssignLabelPopup = ({
  headerTitle,
  headersubtext,
  closehandleFunction,
  closeisDisabled,
  closebuttonRef,
  closeimgColor,
  labels = [],
  setLabels,
  LabelAccounts,
  isLabelPopupOpen,
  filteredData,
  type,
  setSelectedLabelsCreate,
  selectedLabelsCreate = [],
  txnPayLoad,
  handleAssignLabels,
  handleUnassignLabels,
  loading,
  setLoading,
  // selectedAccount,
  // setSelectedAccount,
  // selectedAssignedAccountID,
  // setSelectedAssignedAccountID,
}) => {
  const [animate, setAnimate] = useState(false);
  const [labelSearchName, setLabelSearchName] = useState("");
  const [showHideOne, setShowHideOne] = useState(false);
  const [showHideTwo, setShowHideTwo] = useState(false);
  const [assignSelection, setAssignSelection] = useState([]);
  const [unassignSelection, setUnassignSelection] = useState([]);
  const [showAssignLabel, setshowAssignLabel] = useState(true);
  const [activeTab, setActiveTab] = useState("Assigned");
  const [optimisticAssigned, setOptimisticAssigned] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingAssignBtn, setLoadingAssignBtn] = useState(false);
  const [loadingUnassignBtn, setLoadingUnassignBtn] = useState(false);

  const autoSelectRef = useRef(null);
  const userChangedTabRef = useRef(false);
  const labelInputRef = useRef(null);

  const unassignedLabels = labels?.filter(
    (label) => !optimisticAssigned?.includes(label),
  );

  const selectedAccounts = React?.useMemo(() => {
    return filteredData || [];
  }, [filteredData]);

  const commonAssignedLabels = React?.useMemo(() => {
    if (!selectedAccounts?.length) return [];

    const labelSets = selectedAccounts?.map(
      (item) => new Set(item?.labels || []),
    );

    return [
      ...labelSets?.reduce(
        (a, b) => new Set([...a]?.filter((label) => b?.has(label))),
      ),
    ];
  }, [selectedAccounts]);

  const filteredAssigned = optimisticAssigned?.filter((label) =>
    label?.toLowerCase()?.includes(labelSearchName?.toLowerCase()),
  );

  const filteredUnassigned = unassignedLabels?.filter((label) =>
    label?.toLowerCase()?.includes(labelSearchName?.toLowerCase()),
  );

  const hasAssignedLabels =
    filteredAssigned?.length !== GlobalConfiguration?.lengthCheckZero;

  const hasUnassignLabels =
    filteredUnassigned?.length !== GlobalConfiguration?.lengthCheckZero;

  const handleAssignTrue = () => {
    userChangedTabRef.current = true;
    setshowAssignLabel(true);
    setActiveTab("Assigned");
  };

  const handleUnassignTrue = () => {
    userChangedTabRef.current = true;
    setshowAssignLabel(false);
    setActiveTab("Unassigned");
  };

  const handleInputChange = (value) => {
    const processedValue =
      value
        ?.replace(/[A-Z\s]/g, "")
        ?.substring(
          GlobalConfiguration?.lengthCheckZero,
          GlobalConfiguration?.inputValidationLength,
        ) || "";
    setLabelSearchName(processedValue);
  };

  const trimmedInput = labelSearchName?.trim();
  const labelExists = labels?.some(
    (label) => label?.toLowerCase() === trimmedInput?.toLowerCase(),
  );

  const isButtonDisabled =
    trimmedInput.length < GlobalConfiguration?.searchMinLength ||
    trimmedInput.length > GlobalConfiguration?.inputValidationLength ||
    labelExists;

  const handleNewLabel = async () => {
    if (isButtonDisabled) return;
    const trimmed = labelSearchName?.trim();
    if (!trimmed) return;

    const labelExists = labels.some(
      (l) => l?.toLowerCase() === trimmed?.toLowerCase(),
    );
    if (labelExists) return;
    setLoadingSearch(true);
    setLoading(true);

    const updatedLabels = [...labels, trimmed];
    setLabels(updatedLabels);

    if (type === "create") {
      setSelectedLabelsCreate((prev) =>
        prev?.includes(trimmed) ? prev : [...prev, trimmed],
      );

      setOptimisticAssigned((prev) =>
        prev?.includes(trimmed) ? prev : [...prev, trimmed],
      );

      setTimeout(() => {
        setLoading(false);
        setLoadingSearch(false);
      }, TimelineConfiguration?.timeDuration);
    } else {
      try {
        const showToast = (message) => {
          CommonToast({
            text: message,
            icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
            variant: "var(--processing)",
            buttonNeeded: false,
            btnProps: {
              enabledBgColor: "var(--primary-bg)",
              enabledTextColor: "var(--text-primary)",
              btnText: "",
              handleFunction: () => {},
              icon: "",
              btnType: "button",
              isDisabled: false,
              hoverOption: "white",
            },
          });
        };

        showToast("Assigning labels.");
        await handleAssignLabels([trimmed]);
      } finally {
        setLoading(false);
        setLoadingSearch(false);
      }
    }

    autoSelectRef.current = trimmed;
    setLabelSearchName("");
  };

  const handleAssignedLabelClick = (label) => {
    setUnassignSelection((prev) =>
      prev?.includes(label)
        ? prev?.filter((l) => l !== label)
        : [...prev, label],
    );
  };

  const handleUnassignedLabelClick = (label) => {
    setAssignSelection((prev) =>
      prev?.includes(label)
        ? prev?.filter((l) => l !== label)
        : [...prev, label],
    );
  };

  const recordIds = filteredData?.map((acc) => acc?.id);

  const onAssignClick = async () => {
    if (!assignSelection?.length) return;

    const labelsToAssign = [...assignSelection];
    setLoading(true);
    setLoadingAssignBtn(true);

    const nextAssigned = [
      ...new Set([...optimisticAssigned, ...labelsToAssign]),
    ];
    setOptimisticAssigned(nextAssigned);
    setAssignSelection([]);

    if (type === "create") {
      setSelectedLabelsCreate?.(nextAssigned);
      setTimeout(() => {
        setLoading(false);
        setLoadingAssignBtn(false);
      }, TimelineConfiguration?.timeDuration);
      return;
    }

    const showToast = (message) => {
      CommonToast({
        text: message,
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    };
    showToast("Assigning labels.");
    try {
      const isSuccess = await handleAssignLabels(labelsToAssign, recordIds);
      if (!isSuccess) {
        setOptimisticAssigned((prev) =>
          prev.filter((l) => !labelsToAssign.includes(l)),
        );
        setAssignSelection(labelsToAssign);
      }
    } finally {
      setShowHideTwo(false);
      setLoading(false);
      setLoadingAssignBtn(false);
    }
  };

  const onUnassignClick = async () => {
    if (!unassignSelection?.length) return;

    const labelsToUnassign = [...unassignSelection];
    setLoading(true);
    setLoadingUnassignBtn(true);

    const nextAssigned = optimisticAssigned.filter(
      (label) => !labelsToUnassign.includes(label),
    );
    setOptimisticAssigned(nextAssigned);
    setUnassignSelection([]);

    if (type === "create") {
      setSelectedLabelsCreate?.(nextAssigned);
      setTimeout(() => {
        setLoading(false);
        setLoadingUnassignBtn(false);
      }, TimelineConfiguration?.timeDuration);
      return;
    }

    const showToast = (message) => {
      CommonToast({
        text: message,
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    };
    showToast("Unassigning labels.");
    try {
      const isSuccess = await handleUnassignLabels(labelsToUnassign, recordIds);
      if (!isSuccess) {
        setOptimisticAssigned((prev) => [
          ...new Set([...prev, ...labelsToUnassign]),
        ]);
        setUnassignSelection(labelsToUnassign);
      }
    } finally {
      setShowHideOne(false);
      setLoading(false);
      setLoadingUnassignBtn(false);
    }
  };

  const handleClose = () => {
    if (type === "create") {
      closehandleFunction(optimisticAssigned);
    } else {
      closehandleFunction();
    }
  };

  const toSentenceCase = (text = "") =>
    text.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
    text?.slice(GlobalConfiguration?.lengthCheckOne)?.toLowerCase();

  const needsFullStop = (text = "") => !text?.trim()?.endsWith(".");

  const handleSelectAll = (mode) => {
    if (!labels || labels?.length === GlobalConfiguration?.lengthCheckZero)
      return;

    if (mode === "unassign") {
      if (!filteredAssigned?.length) return;

      const allSelected =
        unassignSelection?.length === filteredAssigned?.length;

      setUnassignSelection(allSelected ? [] : [...filteredAssigned]);
    }

    if (mode === "assign") {
      if (!filteredUnassigned?.length) return;

      const allSelected =
        assignSelection?.length === filteredUnassigned?.length;

      setAssignSelection(allSelected ? [] : [...filteredUnassigned]);
    }
  };

  const allAssignedSelected =
    filteredAssigned?.length > GlobalConfiguration?.lengthCheckZero &&
    unassignSelection?.length === filteredAssigned?.length;

  const isAllUnassignedSelected =
    filteredUnassigned?.length > GlobalConfiguration?.lengthCheckZero &&
    assignSelection?.length === filteredUnassigned?.length;

  useEffect(() => {
    const inputElement = labelInputRef?.current?.querySelector("input");
    if (inputElement) {
      const handleKeyDown = (e) => {
        if (e.key === "Enter" && !isButtonDisabled) {
          e.preventDefault();
          handleNewLabel();
        }
      };
      inputElement.addEventListener("keydown", handleKeyDown);
      inputElement.setAttribute("maxLength", "50");

      return () => {
        inputElement.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isButtonDisabled, labelSearchName]);

  useEffect(() => {
    if (!isLabelPopupOpen) return;
    if (type === "create") return;

    setOptimisticAssigned(commonAssignedLabels);
    setAssignSelection([]);
    setUnassignSelection([]);
  }, [commonAssignedLabels, isLabelPopupOpen, type]);

  useEffect(() => {
    if (!userChangedTabRef?.current && assignSelection?.length) {
      setActiveTab("Assigned");
    }
  }, [assignSelection]);

  useEffect(() => {
    if (!userChangedTabRef?.current && unassignSelection?.length) {
    }
  }, [unassignSelection]);

  useEffect(() => {
    if (unassignSelection?.length === GlobalConfiguration?.lengthCheckZero) {
      setShowHideOne(false);
    }
    if (assignSelection?.length === GlobalConfiguration?.lengthCheckZero) {
      setShowHideTwo(false);
    }
  }, [unassignSelection, assignSelection]);

  useEffect(() => {
    if (type === "create") {
      setOptimisticAssigned(selectedLabelsCreate || []);
    }
  }, [selectedLabelsCreate, type]);

  // const handleAccountSelect = (account, e) => {
  //   const textContent = e?.target?.textContent || account;

  //   if (textContent !== selectedAccount) {
  //     setLoading(true);
  //     setSelectedAccount(
  //       textContent === "All selected accounts" ? textContent : account,
  //     );

  //     const selectedOwnerId =
  //       filteredData?.find((owner) => owner.bank_acc_no === account)?.id || "";

  //     setSelectedAssignedAccountID(
  //       textContent === "All selected accounts" ? "" : selectedOwnerId,
  //     );
  //   }
  // };

  // const labelAccountOptions =
  //   type === "viewall" && filteredData?.length > 1
  //     ? ["All selected accounts", ...filteredData.map((acc) => acc.bank_acc_no)]
  //     : [];

  return (
    <div
      className="flex w-full justify-center items-center m-auto top-1/2 left-1/2 fixed z-z-index-modal p-padding-sm"
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`w-full h-popup-height Qsmd:max-h-labels-popup-height overflow-hidden relative Qmd:w-max-content-width flex flex-col pt-padding-md bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div className="flex flex-col flex-1 overflow-hidden">
          <div className=" flex flex-col gap-gap-xs px-padding-md">
            <div className="flex justify-between gap-gap-md ">
              <div className=" flex gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-font-md text-text-primary font-semibold">
                    {toSentenceCase(headerTitle)}
                  </p>
                  {headersubtext && (
                    <span className="font-normal text-text-secondary text-font-xs">
                      {linkIdentifier(headersubtext)}
                      {needsFullStop(headersubtext) && <span>.</span>}
                    </span>
                  )}
                </div>
              </div>
              <IconRoundButton
                enabledBgColor={"var(--primary-nav-act)"}
                isLoading={false}
                handleFunction={() => {
                  if (!closeisDisabled) {
                    setAnimate(true);
                    setTimeout(() => {
                      handleClose();
                    }, IntervalConfiguration?.intervalSemiMid);
                  }
                }}
                title="Close"
                icon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                hoverOption="white"
                btnType={"button"}
                isDisabled={closeisDisabled}
                buttonRef={closebuttonRef}
                imgColor={closeimgColor}
              />
            </div>
          </div>

          <div className=" flex flex-col Qmd:flex-row  pt-padding-md px-padding-md  gap-gap-sm Qmd:gap-gap-md w-full Qmd:items-center ">
            {/* <div
              className="w-full  Qmd:w-width-sm max-w-full Qmd:max-w-assign-tag-dropdown flex-shrink-0"
              // style={{ display: dummyUser ? "none" : "block" }}
            >
              <SingleSelectDropDownComponent
                options={labelAccountOptions}
                selected={selectedAccount || "All selected accounts"}
                setSelected={(val) => {
                  if (val !== selectedAccount) {
                    const selectedOwner = filteredData.find(
                      (owner) => owner.bank_acc_no === val,
                    );

                    handleAccountSelect(
                      selectedOwner ? selectedOwner.bank_acc_no : "",
                      { target: { textContent: val } },
                    );
                  }
                }}
                type="small"
                placeholder="All selected accounts"
                showSearch={false}
                disabled={type === "details" || filteredData?.length === 1}
              />
            </div> */}

            <div className=" flex-1">
              <SearchBarWithCTA
                btnText={"Assign new label"}
                placeholder={"Search / Enter new label"}
                searchText={labelSearchName}
                inActiveVariantNeeded={true}
                onInput={handleInputChange}
                onClick={handleNewLabel}
                disabledBtnColor={!loadingSearch && "var(--text-disabled)"}
                disabledTxtColor="var(--text-primary)"
                disabledBgColor="var(--text-disabled)"
                disabledTextColor="var(--text-primary)"
                txtColor="var(--text-primary)"
                isBtnDisable={isButtonDisabled}
                searchRef={labelInputRef}
                isSearchDisabled={false}
                isLoaderNeeded={true}
                isLoading={loadingSearch}
                btnColor={"var(--positive-act)"}
                hoverOption="black"
              />
            </div>
          </div>

          <div className="flex w-full lg:hidden px-padding-md pt-padding-md">
            <SwitcherTabs
              initialActiveTab={activeTab}
              tabs={[
                {
                  label: `Assigned - ${optimisticAssigned?.length || GlobalConfiguration?.lengthCheckZero}`,
                  handler: handleAssignTrue,
                  key: "Assigned",
                },
                {
                  label: `Unassigned - ${filteredUnassigned?.length || GlobalConfiguration?.lengthCheckZero}`,
                  handler: handleUnassignTrue,
                  key: "Unassigned",
                },
              ]}
            />
          </div>
          <div className="w-full flex flex-row mt-margin-md bg-primary-card  flex-1 overflow-y-hidden max-h-full overflow-x-hidden">
            <div
              className={`h-full w-full relative lg:flex flex-col 
               ${
                 assignSelection?.length
                   ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none"
                   : ""
               }  ${showAssignLabel ? "flex" : "hidden"}

               `}
            >
              <div className=" flex flex-col gap-gap-xs px-padding-md pt-padding-md  ">
                <div className="flex justify-between gap-gap-md ">
                  <div className=" flex gap-gap-sm">
                    <div className="flex flex-col gap-gap-xs">
                      <p className="text-font-md text-text-primary font-semibold flex items-center justify-start">
                        Assigned labels -{" "}
                        {loading ? (
                          <span className="inline-flex items-center ml-2">
                            <img
                              src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                              className="w-icon-sm h-icon-sm mt-1 flex items-center"
                              alt="loading"
                            />
                          </span>
                        ) : (
                          filteredAssigned?.length ||
                          GlobalConfiguration?.lengthCheckZero
                        )}
                      </p>
                      {filteredAssigned?.length >
                      GlobalConfiguration?.lengthCheckZero ? (
                        <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                          Select labels and click "Unassign" to remove them.
                        </span>
                      ) : filteredAssigned?.length ===
                          GlobalConfiguration?.lengthCheckZero &&
                        labelSearchName ? (
                        <span
                          className={`  font-normal text-text-secondary text-font-xs pb-padding-sm`}
                        >
                          Click on ‘Assign new label’ to assign the label
                          entered above.
                        </span>
                      ) : filteredAssigned?.length ===
                        GlobalConfiguration?.lengthCheckZero ? (
                        <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                          To assign a label, either select from the list of
                          unassigned labels and assign them or type a new label
                          name in the search bar and click ‘Assign’.
                        </span>
                      ) : (
                        <span
                          className="font-normal text-text-secondary text-font-xs pb-padding-sm"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          Click on ‘Assign new label’ to assign the label
                          entered above.
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex-shrink-0 ">
                    <SecondaryRightIconSmallButton
                      btnText="Select all"
                      btnType="button"
                      handleFunction={() => {
                        if (
                          filteredAssigned?.length ===
                            GlobalConfiguration?.lengthCheckZero ||
                          loading
                        )
                          return;
                        handleSelectAll("unassign");
                      }}
                      isDisabled={
                        filteredAssigned?.length ===
                          GlobalConfiguration?.lengthCheckZero || loading
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor={
                        allAssignedSelected
                          ? "var(--positive-bg)"
                          : "var(--primary-nav)"
                      }
                      hoverOption={allAssignedSelected ? "black" : "white"}
                      icon={
                        allAssignedSelected
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className=" flex flex-col relative gap-gap-xs pl-padding-md pt-padding-sm flex-1 overflow-hidden">
                {loading ? (
                  <>
                    <div className="flex justify-center items-center h-full ">
                      <img
                        src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                        alt="loading"
                        className={` w-icon-lg h-icon-lg`}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {hasAssignedLabels ? (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pr-padding-md pb-padding-sm  Qsmd:max-h-full">
                        {filteredAssigned?.map((label, index) => {
                          const isDisabled = loading;

                          return (
                            <Chips
                              key={index}
                              txtChip={label}
                              icon={
                                unassignSelection?.includes(label)
                                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                              }
                              hoverOptionBtn={
                                unassignSelection?.includes(label)
                                  ? "black"
                                  : "white"
                              }
                              enabledBgColor={
                                unassignSelection?.includes(label)
                                  ? "var(--positive-card)"
                                  : "var(--primary-nav-act)"
                              }
                              isDisabled={isDisabled}
                              handleFunctionBtn={() => {
                                if (!isDisabled)
                                  handleAssignedLabelClick(label);
                              }}
                              enabledTextColor="var(--text-primary)"
                              isTickerRequired={true}
                            />
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        className={`flex flex-col justify-center items-center gap-gap-sm ${
                          filteredAssigned?.length ===
                            GlobalConfiguration?.lengthCheckZero &&
                          labelSearchName
                            ? "pt-padding-md"
                            : "pt-padding-sm"
                        } pb-padding-md flex-1  h-full`}
                      >
                        <img
                          className="h-graphic-square-height-sm"
                          src={
                            "https://q2pay.in/new_assets/graphics/general/assign.svg"
                          }
                          alt="nolablefound"
                        />
                        <p className="text-text-secondary text-font-xs font-normal">
                          No assigned labels found.
                        </p>
                      </div>
                    )}
                  </>
                )}
                <div
                  className={`absolute ${showHideOne ? "top-top-base" : "top-full"} overflow-y-auto w-full left-left-base h-full bg-primary-nav transition-all duration-500  ease-in-out border-b-border border-primary-bg`}
                >
                  {unassignSelection?.length >
                    GlobalConfiguration?.lengthCheckZero &&
                    showHideOne && (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pl-padding-md pt-padding-md pr-padding-md pb-padding-sm  Qsmd:max-h-full">
                        {unassignSelection?.map((label) => (
                          <Chips
                            key={label}
                            txtChip={label}
                            icon={
                              "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                            }
                            hoverOption="white"
                            enabledBgColor="var(--primary-nav-act)"
                            handleFunction={() => {
                              handleAssignedLabelClick(label);
                            }}
                            enabledTextColor="var(--text-primary)"
                            isTickerRequired={true}
                          />
                        ))}
                      </div>
                    )}
                </div>
              </div>

              <div className="w-full flex justify-between  relative bg-primary-nav  p-padding-md rounded-bl-border-radius-md z-z-index-header">
                <div className="flex gap-gap-sm items-center">
                  <CommonCountMultiSelect
                    bgColor={"bg-primary-bg"}
                    textColor={"text-text-primary"}
                    count={
                      !loading
                        ? unassignSelection?.length ||
                          GlobalConfiguration?.lengthCheckZero
                        : GlobalConfiguration?.lengthCheckZero
                    }
                  />
                  <p className="text-text-primary text-font-sm font-normal hidden Qsmd:block">
                    {unassignSelection?.length >
                      GlobalConfiguration?.lengthCheckOne ||
                    unassignSelection?.length ===
                      GlobalConfiguration?.lengthCheckZero
                      ? "Labels selected"
                      : "Label selected"}
                  </p>
                </div>
                <div className="flex flex-row-reverse gap-gap-sm">
                  <div>
                    <PrimaryButton
                      btnText={"Unassign"}
                      btnType={"button"}
                      handleFunction={() => {
                        if (
                          !unassignSelection?.length ||
                          loading ||
                          labelSearchName?.length
                        )
                          return;
                        onUnassignClick();
                      }}
                      isDisabled={
                        !unassignSelection?.length ||
                        loading ||
                        labelSearchName?.length
                      }
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--positive-act)"}
                      disabledBgColor={
                        !loadingUnassignBtn && "var(--text-disabled)"
                      }
                      hoverOption={"black"}
                      isLoading={loadingUnassignBtn}
                      inActiveVariantNeeded={
                        !unassignSelection?.length || loading
                      }
                      isLoaderNeeded={true}
                    />
                  </div>

                  <PrimaryButton
                    btnText={"Clear"}
                    handleFunction={() => {
                      if (
                        !unassignSelection?.length ||
                        loading ||
                        labelSearchName?.length
                      )
                        return;
                      setUnassignSelection([]);
                    }}
                    isDisabled={
                      !unassignSelection?.length ||
                      loading ||
                      labelSearchName?.length
                    }
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"transparent"}
                    outLineColor={"var(--text-primary)"}
                    hoverOption="white"
                    btnType="button"
                    isLoading={false}
                    isLoaderNeeded={false}
                  />
                  <div className=" border-l-border border-primary-bg"></div>
                  <PrimaryWithIconButton
                    handleFunction={() => {
                      if (!unassignSelection?.length) return;
                      setShowHideOne((prev) => !prev);
                    }}
                    btnText={!showHideOne ? "Show" : "Hide"}
                    btnType="button"
                    isDisabled={!unassignSelection?.length}
                    enabledBgColor={"var(--primary-bg)"}
                    isLoading={false}
                    hoverOption="white"
                    enabledTextColor={"var(--text-primary)"}
                    icon={
                      showHideOne
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                    }
                    imgColor={"var(--text-primary)"}
                    iconToBeAlign="right"
                    fullWidthRequired={false}
                  />
                </div>
              </div>
            </div>
            <div
              className={`w-full h-full relative border-l-border lg:flex border-primary-bg flex-col flex 
        ${
          unassignSelection?.length
            ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none"
            : ""
        }
         ${activeTab === "Unassigned" ? "flex" : "hidden"}

              
              `}
            >
              <div className=" flex flex-col gap-gap-xs px-padding-md pt-padding-md">
                <div className="flex justify-between gap-gap-md ">
                  <div className=" flex gap-gap-sm">
                    <div className="flex flex-col gap-gap-xs">
                      <p className="text-font-md text-text-primary font-semibold flex items-center justify-start">
                        Unassigned labels -{" "}
                        {loading ? (
                          <span className="inline-flex items-center ml-2">
                            <img
                              src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                              className="w-icon-sm h-icon-sm mt-1 flex items-center"
                              alt="loading"
                            />
                          </span>
                        ) : (
                          filteredUnassigned?.length ||
                          GlobalConfiguration?.lengthCheckZero
                        )}
                      </p>

                      {filteredUnassigned?.length >
                      GlobalConfiguration?.lengthCheckZero ? (
                        <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                          Select labels and click "Assign" to add them.
                        </span>
                      ) : (
                        <span
                          className="font-normal text-text-secondary text-font-xs pb-padding-sm"
                          style={{
                            visibility:
                              filteredUnassigned?.length ===
                                GlobalConfiguration?.lengthCheckZero &&
                              "hidden",
                          }}
                        ></span>
                      )}
                    </div>
                  </div>
                  <div className="flex-shrink-0 ">
                    <SecondaryRightIconSmallButton
                      btnText="Select all"
                      btnType="button"
                      handleFunction={() => {
                        if (
                          filteredUnassigned?.length ===
                            GlobalConfiguration?.lengthCheckZero ||
                          loading
                        )
                          return;
                        handleSelectAll("assign");
                      }}
                      isDisabled={
                        filteredUnassigned?.length ===
                          GlobalConfiguration?.lengthCheckZero || loading
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor={
                        isAllUnassignedSelected
                          ? "var(--positive-bg)"
                          : "var(--primary-nav)"
                      }
                      hoverOption={isAllUnassignedSelected ? "black" : "white"}
                      icon={
                        isAllUnassignedSelected
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className=" flex flex-col gap-gap-xs pl-padding-md  relative flex-1 pt-padding-sm overflow-hidden">
                {loading ? (
                  <>
                    <div className="flex justify-center items-center h-full">
                      <img
                        src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                        alt="loading"
                        className={` w-icon-lg h-icon-lg`}
                      />
                    </div>
                  </>
                ) : filteredUnassigned?.length ===
                  GlobalConfiguration?.lengthCheckZero ? (
                  <div className="flex flex-col justify-center items-center gap-gap-sm py-padding-md flex-1  h-full">
                    <img
                      className="h-graphic-square-height-sm  "
                      src={
                        "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                      }
                      alt="nolablefound"
                    />
                    <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                      No unassigned labels found.
                    </p>
                  </div>
                ) : (
                  <>
                    {hasUnassignLabels ? (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pr-padding-md pb-padding-sm Qsmd:max-h-full">
                        {filteredUnassigned?.map((label, id) => {
                          const isDisabled = loading;

                          return (
                            <Chips
                              key={id}
                              txtChip={label}
                              icon={
                                assignSelection?.includes(label)
                                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                              }
                              hoverOptionBtn={
                                assignSelection?.includes(label)
                                  ? "black"
                                  : "white"
                              }
                              enabledBgColor={
                                assignSelection?.includes(label)
                                  ? "var(--positive-card)"
                                  : "var(--primary-nav-act)"
                              }
                              isDisabled={isDisabled}
                              handleFunctionBtn={() => {
                                if (!isDisabled)
                                  handleUnassignedLabelClick(label);
                              }}
                              enabledTextColor="var(--text-primary)"
                              isTickerRequired={true}
                            />
                          );
                        })}
                      </div>
                    ) : (
                      <div className="flex flex-col justify-center items-center gap-gap-sm py-padding-md flex-1  h-full">
                        {labelSearchName?.length >
                        GlobalConfiguration?.lengthCheckZero ? (
                          <>
                            <img
                              className="h-graphic-square-height-sm  "
                              src={
                                "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                              }
                              alt="nolablefound"
                            />
                            <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                              No unassigned labels found.
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              className="h-graphic-square-height-sm  "
                              src={
                                "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                              }
                              alt="nolablefound"
                            />
                            <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                              No unassigned labels found.
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
                <div
                  className={`absolute ${showHideTwo ? "top-top-base" : "top-full"} w-full left-left-base h-full bg-primary-nav transition-all duration-animation-fast  ease-in-out border-b-border border-primary-bg`}
                >
                  {assignSelection?.length >
                    GlobalConfiguration?.lengthCheckZero &&
                    showHideTwo && (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pl-padding-md pt-padding-md pr-padding-md pb-padding-sm Qsmd:max-h-full">
                        {assignSelection?.map((label) => (
                          <Chips
                            key={label}
                            txtChip={label}
                            icon={
                              "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                            }
                            hoverOption="white"
                            enabledBgColor="var(--primary-nav-act)"
                            handleFunction={() => {
                              handleUnassignedLabelClick(label);
                            }}
                            isTickerRequired={true}
                            enabledTextColor="var(--text-primary)"
                          />
                        ))}
                      </div>
                    )}
                </div>
              </div>
              <div className="flex w-full justify-between  relative bg-primary-nav  p-padding-md rounded-br-border-radius-md z-z-index-header">
                <div className="flex gap-gap-sm items-center">
                  <CommonCountMultiSelect
                    bgColor={"bg-primary-bg"}
                    textColor={"text-text-primary"}
                    count={
                      !loading
                        ? assignSelection?.length ||
                          GlobalConfiguration?.lengthCheckZero
                        : GlobalConfiguration?.lengthCheckZero
                    }
                  />
                  <p className="text-text-primary text-font-sm font-normal hidden Qsmd:block">
                    {assignSelection?.length >
                      GlobalConfiguration?.lengthCheckOne ||
                    assignSelection?.length ===
                      GlobalConfiguration?.lengthCheckZero
                      ? "Labels selected"
                      : "Label selected"}
                  </p>
                </div>
                <div className="flex flex-row-reverse gap-gap-sm">
                  <div>
                    <PrimaryButton
                      btnText={"Assign"}
                      btnType={"button"}
                      handleFunction={() => {
                        if (
                          !assignSelection?.length ||
                          loading ||
                          labelSearchName?.length
                        )
                          return;
                        onAssignClick();
                      }}
                      isDisabled={
                        !assignSelection?.length ||
                        loading ||
                        labelSearchName?.length
                      }
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--positive-act)"}
                      disabledBgColor={
                        !loadingAssignBtn && "var(--text-disabled)"
                      }
                      hoverOption={"black"}
                      isLoading={loadingAssignBtn}
                      inActiveVariantNeeded={
                        !assignSelection?.length || loading
                      }
                      isLoaderNeeded={true}
                    />
                  </div>

                  <PrimaryButton
                    btnText={"Clear"}
                    handleFunction={() => {
                      if (
                        !assignSelection?.length ||
                        loading ||
                        labelSearchName?.length
                      )
                        return;

                      setAssignSelection([]);
                    }}
                    isDisabled={
                      !assignSelection?.length ||
                      loading ||
                      labelSearchName?.length
                    }
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"transparent"}
                    outLineColor={"var(--text-primary)"}
                    hoverOption="white"
                    btnType="button"
                    isLoading={false}
                    isLoaderNeeded={false}
                  />
                  <div className=" border-l-border border-primary-bg"></div>
                  <PrimaryWithIconButton
                    handleFunction={() => {
                      if (!assignSelection?.length || loading) return;
                      setShowHideTwo((prev) => !prev);
                    }}
                    btnText={!showHideTwo ? "Show" : "Hide"}
                    btnType="button"
                    isDisabled={!assignSelection?.length}
                    enabledBgColor={"var(--primary-bg)"}
                    isLoading={false}
                    hoverOption="white"
                    enabledTextColor={"var(--text-primary)"}
                    icon={
                      showHideTwo
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                    }
                    imgColor={"var(--text-primary)"}
                    iconToBeAlign="right"
                    fullWidthRequired={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonAssignLabelPopup;
